import React from 'react';
import Navbar from '../components/Navbar';
import Home from '../components/pages/Home';
import Blog from '../components/pages/Blog';
import Jobs from '../components/pages/Jobs';
import Intro from '../components/pages/Intro';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Finances from '../components/pages/Finances';
import Products from '../components/pages/Products';
import SignUp from '../components/pages/SignUp';
import TermsConditions from '../components/pages/TermsConditions';
import PrivacyPolicy from '../components/pages/PrivacyPolicy';
import Currency from '../components/pages/Currency';
import Portfolio from '../components/pages/Portfolio';
import Subscribe from '../components/pages/Subscribe';


function DesktopRoutes() {
    return (
      <>
        <Router>
          <Navbar />
          <Routes>
            <Route path='/' element={<Intro/>} />
            <Route path='/home' element={<Home/>} />
            <Route path='/finances' element={<Finances/>} />
            <Route path='/blog' element={<Blog/>} />
            <Route path='/products' element={<Products/>} />
            <Route path='/currency' element={<Currency/>} />
            <Route path='/jobs' element={<Jobs/>} />
            <Route path='/portfolio' element={<Portfolio/>} />
            <Route path='/sign-up' element={<SignUp/>} />
            <Route path='/terms-conditions' element={<TermsConditions/>} />
            <Route path='/privacy-policy' element={<PrivacyPolicy/>} />
            <Route path='/subscribe' element={<Subscribe/>} />
      
          </Routes>
        </Router>
      </>
    );
  }
  
  export default DesktopRoutes;
  